import { render, staticRenderFns } from "./ProductFilterDashBoard.vue?vue&type=template&id=e25b7144&"
import script from "./ProductFilterDashBoard.vue?vue&type=script&lang=js&"
export * from "./ProductFilterDashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports